import * as Yup from "yup";

import { validaCpf } from "../../../utils/validations";

const editDependentSchema = Yup.object({
  nome: Yup.string()
    .required(`Nome obrigatório`)
    .max(79, "O nome deve ter no máximo 79 caracteres")
    .test("lastName", "Insira pelo menos um sobrenome", (name) => {
      if (!name) {
        return false;
      }
      const formattedName = name.trim().split(" ");
      return formattedName?.length > 1;
    }),

  nomeSocial: Yup.string()
    .min(3, "O nome social deve ter no mínimo 3 caracteres.")
    .max(80, "O nome social deve ter no máximo 80 caracteres.")
    .nullable()
    .optional(),

  dataNascimento: Yup.string()
    .required("Data nascimento obrigatório")
    .test("dataNascimento", "A data de nascimento é inválida", (value) => {
      if (!value) return false;

      const dateFormated = value.replace(/_/g, "").replace(/\//g, "-");
      if (dateFormated.length < 10) return false;

      const dateParts = dateFormated.split("-");
      const day = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10);
      const year = parseInt(dateParts[2], 10);

      if (month > 12 || month < 1 || day < 1 || day > 31) return false;

      const currentYear = new Date().getFullYear();
      const minYear = currentYear - 100;

      if (year > currentYear || year < minYear) return false;

      const diasPorMes: Record<number, number> = {
        1: 31,
        2: 29,
        3: 31,
        4: 30,
        5: 31,
        6: 30,
        7: 31,
        8: 31,
        9: 30,
        10: 31,
        11: 30,
        12: 31,
      };

      if (
        month === 2 &&
        year % 4 === 0 &&
        (year % 100 !== 0 || year % 400 === 0)
      ) {
        diasPorMes[2] = 29;
      }

      if (day > diasPorMes[month]) return false;

      const birthDate = new Date(year, month - 1, day);
      const currentDate = new Date();

      if (birthDate >= currentDate) return false;

      return true;
    }),
  cpf: Yup.string()
    .required(`Cpf obrigatório`)
    .test("cpf", "O CPF é inválido", (value) => {
      if (!value) return false;
      const cpfFormated = value.split(".").join("").replace("-", "");
      return validaCpf(cpfFormated);
    }),
  sexo: Yup.string().required(`Sexo obrigatório`),
  grauParentesco: Yup.string().required(`Grau de parentesco obrigatório`),
  nomeMae: Yup.string()
    .required(`Nome da mãe obrigatório`)
    .max(79, "O nome da mae deve ter no máximo 79 caracteres")
    .test("lastName", "Insira pelo menos um sobrenome", (motherName) => {
      if (!motherName) {
        return false;
      }
      const formattedName = motherName.trim().split(" ");
      return formattedName?.length > 1;
    }),
  area: Yup.string()
    .required(`DDD obrigatório`)
    .min(2, "DDD inválido")
    .max(2, "DDD inválido")
    .matches(/^[0-9]+$/, "O campo deve conter apenas números"),
  telefone: Yup.string()
    .required("Telefone obrigatório")
    .matches(/^\d{5}-\d{4}$/, "O telefone deve estar no formato 99999-9999"),
});

export default editDependentSchema;
